import type { SelectOption } from '../components/ui/Select'
import type { DriverAvailability, DriverLanguage, DriverRecord, VehicleCategory } from '../types'
import {
  driverAvailabilities,
  driverAvailabilityLabels,
  driverLanguages,
  vehicleCategories,
} from './drivers'

/** Sentinel for the "no filter applied" option in each select. */
export const ANY = 'any'

export type AvailabilityFilter = DriverAvailability | typeof ANY
export type CategoryFilter = VehicleCategory | typeof ANY
export type LanguageFilter = DriverLanguage | typeof ANY

export type DriverFilters = {
  query: string
  availability: AvailabilityFilter
  category: CategoryFilter
  language: LanguageFilter
}

export const defaultDriverFilters: DriverFilters = {
  query: '',
  availability: ANY,
  category: ANY,
  language: ANY,
}

/** The design's closed trigger reads "Availability", so that doubles as the clear option. */
export const availabilityOptions: SelectOption<AvailabilityFilter>[] = [
  { value: ANY, label: 'Availability' },
  ...driverAvailabilities.map((availability) => ({
    value: availability,
    label: driverAvailabilityLabels[availability],
  })),
]

export const categoryOptions: SelectOption<CategoryFilter>[] = [
  { value: ANY, label: 'All Categories' },
  ...vehicleCategories.map((category) => ({ value: category, label: category })),
]

export const languageOptions: SelectOption<LanguageFilter>[] = [
  { value: ANY, label: 'All' },
  ...driverLanguages.map((language) => ({ value: language, label: language })),
]

export const filterDrivers = (drivers: DriverRecord[], filters: DriverFilters) => {
  const query = filters.query.trim().toLowerCase()

  return drivers.filter((driver) => {
    if (query && !driver.name.toLowerCase().includes(query)) return false
    if (filters.availability !== ANY && driver.availability !== filters.availability) return false
    if (filters.category !== ANY && driver.vehicle.category !== filters.category) return false

    return filters.language === ANY || driver.language === filters.language
  })
}
